import Form from 'components/form'
import { ModalContextProvider } from 'plugins/plugins/leases_plugin/javascripts/ModalContext'
import React, { memo } from 'react'

const FormV3 = ({ formId, width, top }) => {
  return (
    <ModalContextProvider>
      <div style={{ margin: 'auto', width, position: 'absolute', left: '50%', transform: `translate(-50%,${top}px)` }}>
        <Form form_id={formId} viewOnly={true} />
      </div>
    </ModalContextProvider>
  )
}

export default memo(FormV3)
